/*Decided to take the old-fashioned scss styling approach for this one, just to mix things up */

import { Box } from '@mui/system';
import React, { useMemo, useState } from 'react';
import './styles.scss'; 
import theme from '../../muiTheme';
import { alpha } from '@mui/material';
import BurgerIcon from '../Icons/AnimatedPlusIcon/AnimatedPlusIcon';
import AnimatedPlusIcon from '../Icons/AnimatedPlusIcon/AnimatedPlusIcon';
import { Button, Typography, useMediaQuery } from '@mui/material';
import { FiX, FiLogOut, FiLogIn, FiGrid, FiImage, FiHash, FiBookmark, FiHeart  } from "react-icons/fi";
import { useLayoutEffect } from 'react';
import { useEffect } from 'react';
import UserAvatar from '../UserAvatar/UserAvatar';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../actions/auth';
import placeHolderImage from "../../images/post_placeholder.jpeg";
import jwt_decode from "jwt-decode";

const FloatingOptions = ({setShowForm}) => {
    
    const [expanded, setExpanded] = useState(false);
    const authStateSlice = useSelector((state) => state.authReducer);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const [options, setOptions] = useState([]); 
    const [user, setUser] = useState(null);
    const [preload, setPreload] = useState('preload');
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [enabled, setEnabled] = useState(true);

    useEffect(()=>{

        console.log('floater mounted');

        return () => {
            console.log('floater unmounted');
        }
    }, []);

    const handleClick = (event, active) => {

        setExpanded(!active);
    }

    const containerClick = (event) =>{

        console.log('container clicked');

        let className = event.target.getAttribute('class') || ''; 

        console.log('class name: ', className);
        const conditions = ["options-float-container", "profile-container", "user-profile"];

        if(conditions.some(condition => className.includes(condition))){
            setExpanded(false); 
        }
    }

    const signOut = () => {

        dispatch(logout());

        navigate('/');

    }

    const signIn = () => {

        navigate('/auth');
    }

    const signUp = () => {

        navigate('/auth?signup=true');
    }

    const dOptions = [

        
        // {
        //     label: 'Explore',
        //     icon: <FiGrid />, 
        //     action: ()=>{}
        // }
        // {
        //     label: `${profile ? 'Sign Out' : 'Sign In / Sign Up'}`,
        //     icon: profile ? <FiLogOut /> : <FiLogIn />, 
        //     action: ()=>{}
        // }

    ];

    const mOptions = [

        {
            label: 'Explore',
            id:'floater_explore_posts',
            icon: <FiGrid />, 
            action: ()=>{}
        }
        // {
        //     label: `${profile ? 'Sign Out' : 'Sign In / Sign Up'}`,
        //     icon: profile ? <FiLogOut /> : <FiLogIn />, 
        //     action: ()=>{}
        // }

    ];

    const profileOptions = [
        {
            label: 'New Post',
            id:'floater_new_post',
            icon: <FiImage />, 
            action: ()=>{
                setExpanded(false);
                setShowForm(true);
            }
        },
        {
            label: 'Liked Posts',
            id:'floater_liked_posts',
            icon: <FiHeart />, 
            action: ()=>{}
        },
        {
            label: 'Saved',
            id:'floater_saved_posts',
            icon: <FiBookmark />, 
            action: ()=>{}
        },
    ]; 

    const signInOption = {
        label: `Sign In`,
        icon: <FiLogIn />, 
        action: signIn,
        id:'floater_sign_in'
    }; 

    const signOutOption = {
        label: `Sign Out`,
        icon: <FiLogOut />, 
        action: signOut,
        id:'floater_sign_out'
    }; 

    const floatBoxStyle = user ? {
            backgroundImage: `url(${user.profileImage || placeHolderImage})`,
            backgroundSize: 'contain',
            boxSizing: 'border-box',
            boxShadow: 'rgb(255 255 255 / 71%) 0px 0px 0px 5px, rgb(17 17 26 / 56%) 0px 0px 12px 1px'
        } : 
        {
            //boxShadow: 'rgb(17 17 26 / 24%) 0px 1px 0px, rgb(17 17 26 / 44%) 0px 0px 8px;'
            boxShadow: 'rgb(255 255 255 / 22%) 0px 0px 0px 6px, rgb(17 17 26 / 44%) 0px 0px 8px'
        }; 

    useEffect(()=>{


        setPreload('preload');

    }, [user]);

    useMemo(()=>{

        let coreOptions = isMobile ? mOptions : dOptions;

        coreOptions = user ? [...coreOptions, ...profileOptions] : [...coreOptions, signInOption];

        setOptions(coreOptions);

        setTimeout(()=>{
            setPreload(''); //remove animation-duration 0
        }, [1000]);

    }, [user]);

    useEffect(()=>{

        setExpanded(false);

        const pathCheck = pathname.indexOf('auth') !== -1 || pathname.indexOf('profile/edit') !== -1;

        if( pathCheck && enabled){

            setEnabled(false);
        }else if(!enabled){

            setEnabled(true);
        }

    }, [pathname]);

    useEffect(()=>{

        //Process profile when the state slice mutates/changes (I know the state is immutable - but you know what I mean)
        processProfile();

    },[authStateSlice]);

    const processProfile = () => {

        var profile = authStateSlice.authData; 

        if(profile){
            setUser(profile.result);

        }else {
            setUser(null);
        }
    }

    return (
        <Box
            className={'options-float-container '+(expanded ? 'full-screen dim-background' : 'contained clear-background') + (enabled ? ' show-float' : ' hide-float')}
            sx={{
                '--background-color': theme.palette.primary.main,
                '--background-color-2': theme.palette.darkPink,
            }}
            onClick={containerClick}
        >

            <Box
                className={'profile-container ' + (expanded ? 'show-profile ' : 'hide-profile ') + preload}
            >

                {
                    user ? 
                    
                    <Box
                        className={'user-profile '+ (expanded ? 'show-profile-content ' : 'hide-profile-content ') + preload}
                    >
                        <UserAvatar 
                            name={user.name} 
                            imageURL={user.profileImage}
                            url={`/profile/`}
                            sx={{
                                width: '100vw', 
                                justifyContent: 'center', 
                                flexDirection: 'column', 
                                marginTop: '0px'
                            }} 
                            imageSx={{height: '90px', width: '90px'}} 
                            nameSx={{color: 'white', marginTop: '5px'}}
                            verified={user.verified}
                            />

                        <Button onClick={signOut} variant='main' color='secondary'>
                            Sign Out
                        </Button>
                    </Box>

                    :

                    <Box
                        className={'user-profile guest-user '+ (expanded ? 'show-profile-content ' : 'hide-profile-content ') + preload}
                    >
                        <Typography variant='h5' sx={{color: 'white'}}>
                            Don't Have an Account?
                        </Typography>

                        <Button onClick={signUp} variant='main' color='secondary'>
                            Sign Up!
                        </Button>

                    </Box>
                }

            </Box>

            {
                
                options.map((item, index)=>{

                    return (

                        <Box
                            key={item.id}
                            className={'child ' + (expanded ? 'show-child ' : 'hide-child ') + preload}
                            sx={{
                                '--show-delay': (options.length-index)*100+'ms',
                                '--close-delay': index*100+'ms',
                            }}

                            onClick={item.action}
                        >

                            <Box 
                                className={'option-label '+(expanded ? 'show-label ' : 'hide-label ') + preload}
                                sx={{
                                    '--show-label-delay': (options.length-index)*100+200+'ms',
                                    '--close-label-delay': index*100-200+'ms',
                                }}
                                >

                                <Typography variant='body2'>
                                    {item.label}
                                </Typography>
                            
                            </Box>

                            <Box className='inner-content'>

                                {item.icon}

                            </Box>

                        </Box>
                    );
                })
            }


            <Box

                className={'first-child '}
                sx={floatBoxStyle}
            >
                <Box className='inner-content'
                    sx={{
                        background: alpha(user ? theme.palette.secondary.main : theme.palette.primary.main, 0.4),
                        //border: user ? '0px solid white' : 'none'
                    }}
                >

                    <AnimatedPlusIcon active={expanded} onClick={handleClick}/>

                </Box>

            </Box>



            


        </Box>
    );
}

export default FloatingOptions; 